import { render, staticRenderFns } from "./OutcomeForm.vue?vue&type=template&id=222c23b0"
import script from "./OutcomeForm.vue?vue&type=script&lang=js"
export * from "./OutcomeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports